import script from "./BlockManualDomiciliationAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockManualDomiciliationAmount.vue?vue&type=script&setup=true&lang=js"

import "./BlockManualDomiciliationAmount.vue?vue&type=style&index=0&id=5606bbb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5606bbb0"]])

export default __exports__